import React from 'react';
import { Card, Typography } from '@material-ui/core';
import { useStyles } from './integrityCard.module';

const IntegrityCard = ({ title, description }) => {
  const classes = useStyles();

  return (
    <Card className={classes.card}>
      <Typography component="h3" className={classes.title}>
        {title}
      </Typography>

      <Typography component="p" className={classes.description}>
        {description}
      </Typography>
    </Card>
  );
};

export default IntegrityCard;
